import React from 'react'
import Ask from './Ask'
import Brochure from './Brochure'
// import SponsorList from './SponsorList'

export default function Sponsors() {
    return(
        <div>
            {/* <SponsorList /> */}
            <Brochure />
            <Ask />
        </div>
    )
}